
const Header = () => {
  return (
    <div className="header d-flex justify-content-center align-items-center">
        <h1>TRACK YOUR TASKS</h1>
    </div>
  )
}

export default Header